import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const ViewSubsidyDocuments = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/subsidy-documents/subsidy-document/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Details!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);
  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">Subsidy & Documents</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Documents</h2>
            </div>

            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Client Name</label>
                  <div className="w-100 col">
                    {(data?.clientProject?.clientName || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Aadhar card photo front
                  </label>
                  <div className="w-100 col">
                    {data.aadharcardPhotoFront ? (
                      <LazyImageComponent
                        width="70%"
                        src={data.aadharcardPhotoFront}
                        alt={"Aadhar card front"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Aadhar card photo back
                  </label>
                  <div className="w-100 col">
                    {data?.aadharcardPhotoBack ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.aadharcardPhotoBack}
                        alt={"Aadhar card back"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3"> Work order</label>
                  <div className="w-100 col">
                    {data?.workOrder ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.workOrder}
                        alt={"Work order"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3"> Cibil report</label>
                  <div className="w-100 col">
                    {data?.cibilReport ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.cibilReport}
                        alt={"Cibil report"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3"> ITR report</label>
                  <div className="w-100 col">
                    {data?.ITRReport ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.ITRReport}
                        alt={"ITR report"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Cast certificate
                  </label>
                  <div className="w-100 col">
                    {data?.castCertificate ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.castCertificate}
                        alt={"Cast certificate"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Farmer certificate
                  </label>
                  <div className="w-100 col">
                    {data?.farmerCertificate ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.farmerCertificate}
                        alt={"Farmer certificate"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Rental documents
                  </label>
                  <div className="w-100 col">
                    {data?.rentalDocuments ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.rentalDocuments}
                        alt={"Farmer certificate"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewSubsidyDocuments;
